/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Order_6Inputs */

const en_flow_order_6 = /** @type {(inputs: Flow_Order_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents and tracking wait in Frontrow.`)
};

/**
* | output |
* | --- |
* | "Documents and tracking wait in Frontrow." |
*
* @param {Flow_Order_6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_order_6 = /** @type {((inputs?: Flow_Order_6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Order_6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_order_6(inputs)
});